var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-arrangement-setting scope-arrangements"
  }, [_c('div', {
    staticClass: "top-bar background-white box-shadow-small border-radius"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-checkbox', {
    staticClass: "ml-10",
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.toggleAllChecked
    },
    model: {
      value: (_vm.allChecked),
      callback: function($$v) {
        _vm.allChecked = $$v
      },
      expression: "allChecked"
    }
  }, [_vm._v("全选\n                ")]), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checkedPhase),
      callback: function($$v) {
        _vm.checkedPhase = $$v
      },
      expression: "checkedPhase"
    }
  }, [_c('el-checkbox', {
    staticClass: "ml-10",
    attrs: {
      "label": "0"
    }
  }, [_vm._v("全选一面")]), _vm._v(" "), _c('el-checkbox', {
    staticClass: "ml-10",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("全选二面")]), _vm._v(" "), _c('el-checkbox', {
    staticClass: "ml-10",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("全选三面")]), _vm._v(" "), _c('el-checkbox', {
    staticClass: "ml-10",
    attrs: {
      "label": "3"
    }
  }, [_vm._v("全选四面")])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.addNextPhase
    }
  }, [_vm._v("全部追加一个面试阶段")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 14
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "type": "primary",
      "title": "会自动忽略已评价记录"
    },
    on: {
      "click": _vm.saveSelectedData
    }
  }, [_vm._v("\n                    保存已选中数据\n                ")]), _vm._v(" "), _c('arrange-common', {
    on: {
      "sendEmail": _vm.sendEmail
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.saveToMine
    }
  }, [_vm._v("保存到我的面试")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        return _vm.$router.back()
      }
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text-center multi-setting",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("面试阶段")]), _vm._v(" "), _c('div', {
    staticClass: "betch"
  }, [_c('el-select', {
    staticClass: "betch-left",
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.topObj.turnType),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "turnType", $$v)
      },
      expression: "topObj.turnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "一面",
      "value": "0,0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "一面(HR面)",
      "value": "0,1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二面",
      "value": "1,0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二面(HR面)",
      "value": "1,1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "三面",
      "value": "2,0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "三面(HR面)",
      "value": "2,1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "四面",
      "value": "3,0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "四面(HR面)",
      "value": "3,1"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('turnType')
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("面试时间")]), _vm._v(" "), _c('div', {
    staticClass: "betch"
  }, [_c('el-date-picker', {
    staticClass: "betch-left",
    attrs: {
      "size": "medium",
      "format": "yyyy-MM-dd HH:mm",
      "type": "datetime",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.topObj.interviewDate),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "interviewDate", $$v)
      },
      expression: "topObj.interviewDate"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('interviewDate')
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("面试形式")]), _vm._v(" "), _c('div', {
    staticClass: "betch"
  }, [_c('el-select', {
    staticClass: "betch-left",
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.topObj.interviewType),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "interviewType", $$v)
      },
      expression: "topObj.interviewType"
    }
  }, _vm._l((_vm.selectMap.WB_INTERVIEW_TYPE), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('interviewType')
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("面试官")]), _vm._v(" "), _c('div', {
    staticClass: "betch"
  }, [_c('user-search', {
    ref: "topInterviewer",
    staticClass: "betch-left",
    staticStyle: {
      "width": "60%",
      "display": "inline-block"
    },
    attrs: {
      "holder": "面试官"
    },
    model: {
      value: (_vm.topObj.masterInterviewer),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "masterInterviewer", $$v)
      },
      expression: "topObj.masterInterviewer"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('masterInterviewer')
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("面试地点")]), _vm._v(" "), _c('div', {
    staticClass: "betch"
  }, [_c('el-input', {
    staticClass: "betch-left",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "size": "medium",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.topObj.interviewPlace),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "interviewPlace", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "topObj.interviewPlace"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('interviewPlace')
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), (_vm.listData) ? _c('div', {
    staticClass: "arrangement-list"
  }, _vm._l((_vm.listData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box-shadow-small border-radius mt-20"
    }, [_c('arrangement-item', {
      ref: "arrangement",
      refInFor: true,
      staticClass: "background-white mb-10",
      attrs: {
        "isSingle": false,
        "init": item
      },
      on: {
        "sendEmail": _vm.sendEmail,
        "checkbox": _vm.counterCheckbox
      }
    })], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('email-sender', {
    ref: "sendEmail"
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c8c0718"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/arrangement/arrangements.vue
// module id = null
// module chunks = 